import { schema } from 'normalizr';
import { createAction } from 'redux-api-middleware';
import { handleResponse, handleError } from '../utils';

export const FETCH_TASKS_REQUEST = 'FETCH_TASKS_REQUEST';
export const FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';
export const FETCH_TASKS_FAILURE = 'FETCH_TASKS_FAILURE';

export const taskSchema = new schema.Entity('tasks', {}, { idAttribute: 'resourceId' });

export const fetchTasks = areas =>
  createAction({
    endpoint: `${window.config.apiUrl}/tasks?areas=${areas.toString()}`,
    method: 'GET',
    types: [
      { type: FETCH_TASKS_REQUEST },
      {
        type: FETCH_TASKS_SUCCESS,
        payload: (action, state, res) => handleResponse([taskSchema], action, state, res),
      },
      { type: FETCH_TASKS_FAILURE, payload: handleError },
    ],
  });
